import React, {Fragment} from 'react';

import { processResponse } from '../../../utilities/processResponse';

import './Section.css';

const ItemSection = (props) => {

    return (
        <Fragment>
            {
                props.type === "itemInstructionPreSection" ?
                    <div
                        className={`${props.className} _ItemPagePreSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : props.type === "itemInstructionPostSection" ?
                    <div
                        className={`${props.className} _ItemPagePostSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : props.type === "itemCompletionPreSection" ?
                    <div
                        className={`${props.className} _ItemPagePreSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : props.type === "itemCompletionPostSection" ?
                    <div
                        className={`${props.className} _ItemPagePostSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : props.type === "itemPreSection" ?
                    <div
                        className={`${props.className} _ItemPagePreSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : props.type === "itemPostSection" ?
                    <div
                        className={`${props.className} _ItemPagePostSection`}
                        dangerouslySetInnerHTML={{__html: processResponse(props.html)}}
                    ></div>
                : null
            }
        </Fragment>

    );
}

export default ItemSection;
